import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '../../assets/apple.png';
import _imports_1 from '../../assets/blocked.png';
import _imports_2 from '../../assets/google.png';
import _imports_3 from '../../assets/outlook.png';
import _imports_4 from '../../assets/recurring.png';
import _imports_5 from '../../assets/invalid.png';
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "flex gap-2 items-start overflow-hidden h-full truncate" };
const _hoisted_3 = {
    key: 0,
    class: ""
};
const _hoisted_4 = {
    key: 0,
    src: _imports_0,
    class: "h-4 w-4 mb-1"
};
const _hoisted_5 = {
    key: 1,
    src: _imports_1,
    class: "h-4 w-4 mb-1"
};
const _hoisted_6 = {
    key: 2,
    src: _imports_2,
    class: "h-4 w-4 mb-1"
};
const _hoisted_7 = {
    key: 3,
    src: _imports_3,
    class: "h-4 w-4 mb-1"
};
const _hoisted_8 = {
    key: 4,
    src: _imports_4,
    class: "h-4 w-4 mb-1"
};
const _hoisted_9 = {
    key: 5,
    src: _imports_5,
    class: "h-4 w-4 mb-1"
};
const _hoisted_10 = { class: "flex min-w-max gap-4 items-start text-xs" };
const _hoisted_11 = { class: "flex-1 font-semibold flex flex-col gap-y-1.5" };
const _hoisted_12 = { class: "w-48" };
const _hoisted_13 = {
    key: 0,
    class: "flex items-center gap-1"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    class: "h-5 w-5"
}, null, -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("p", null, "iCloud Calendar", -1);
const _hoisted_16 = [
    _hoisted_14,
    _hoisted_15
];
const _hoisted_17 = {
    key: 1,
    class: "flex items-center gap-1"
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_2,
    class: "h-5 w-5"
}, null, -1);
const _hoisted_19 = {
    key: 2,
    class: "flex items-center gap-1"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_3,
    class: "h-5 w-5"
}, null, -1);
const _hoisted_21 = {
    key: 3,
    class: "flex items-center gap-1"
};
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    class: "h-5 w-5"
}, null, -1);
const _hoisted_23 = {
    key: 4,
    class: "flex items-center gap-1"
};
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_4,
    class: "h-5 w-5"
}, null, -1);
const _hoisted_25 = {
    key: 5,
    class: "flex items-center gap-1"
};
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_5,
    class: "h-5 w-5"
}, null, -1);
const _hoisted_27 = { class: "min-w-max" };
const _hoisted_28 = { class: "font-bold" };
import calendarWidgetState from '@/helper/calendarWidgetStates';
import { BOOKED_STATUS, CANCELLED_APPOINMENT, CONFIREMED_APPOINMENT, INVALID_APPOINMENT, NEW_APPOINMENT, NO_SHOW_APPOINMENT, SHOWED_APPOINMENT, } from '@/helper/const';
import { assignEventColor, getTimeDifferenceInMin } from '@/helper/helper';
import { UITooltip } from '@gohighlevel/ghl-ui';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EventTile',
    props: {
        arg: null,
        calendars: {
            type: Array,
            default: () => [],
        },
        groups: {
            type: Array,
            default: () => [],
        },
        users: {
            type: Array,
            default: () => [],
        },
        loggedInUserId: String,
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const eventBackgroundColor = ref('');
        const eventTextColor = ref('');
        const eventBorderColor = ref('');
        const eventTextFormat = ref('');
        const diagonalBackground = ref('');
        function getDisplayColor(eventId, data, activeView) {
            var _a;
            if (!eventId)
                return '';
            if ((data === null || data === void 0 ? void 0 : data.length) == 0)
                return '';
            if (activeView == 'user' ||
                activeView == 'group' ||
                activeView == 'calendar') {
                const found = props.calendars.find(item => item.id === props.arg.event.extendedProps.ogEvent.calendarId);
                if (!found)
                    return (_a = props.arg.event.extendedProps) === null || _a === void 0 ? void 0 : _a.customColor;
                return found === null || found === void 0 ? void 0 : found.eventColor;
            }
            // if (activeView == 'group') return props.arg.event.extendedProps?.customColor
            const found = data.find(item => item.id == eventId);
            if (!found)
                return '';
            return found === null || found === void 0 ? void 0 : found.eventColor;
        }
        function calculateBackground(v) {
            const event = v.event.extendedProps.ogEvent;
            let currentId = '';
            let selectedViewData = [];
            switch (calendarWidgetState.activeView) {
                case 'calendar':
                    currentId = event.calendarId;
                    selectedViewData = props.calendars;
                    break;
                case 'group':
                    currentId = event.calendarId;
                    selectedViewData = props.calendars;
                    break;
                case 'user':
                    currentId = event.assignedUserId;
                    selectedViewData = assignEventColor(props.users);
                    break;
                default:
                    break;
            }
            const accentColor = getDisplayColor(currentId, selectedViewData, calendarWidgetState.activeView) || '#155EEF';
            if (event.status == BOOKED_STATUS) {
                if (event.appointmentStatus == NEW_APPOINMENT ||
                    event.appointmentStatus == INVALID_APPOINMENT) {
                    eventBackgroundColor.value = `#fff`;
                    eventTextColor.value = `color: ${accentColor};`;
                    eventBorderColor.value = `2px solid ${accentColor}`;
                }
                else if (event.appointmentStatus == CONFIREMED_APPOINMENT ||
                    event.appointmentStatus == SHOWED_APPOINMENT) {
                    // show
                    eventBackgroundColor.value = `${accentColor}`;
                    eventTextColor.value = `color: #fff`;
                    eventBorderColor.value = `2px solid ${accentColor}`;
                }
                else if (event.appointmentStatus == CANCELLED_APPOINMENT ||
                    event.appointmentStatus == NO_SHOW_APPOINMENT) {
                    //  no show
                    eventTextFormat.value = 'line-through';
                    eventBackgroundColor.value = `#fff`;
                    eventTextColor.value = `color: ${accentColor};`;
                    eventBorderColor.value = `2px solid ${accentColor}`;
                }
            }
            else {
                if (event.isFree) {
                    eventBackgroundColor.value = `#fff`;
                    eventTextColor.value = `color: ${accentColor};`;
                    eventBorderColor.value = `2px solid ${accentColor}`;
                }
                else {
                    eventBackgroundColor.value = `#e1e1e1`;
                    //     eventBackgroundColor.value = `background-color: #fff;
                    // opacity: 1;
                    // background: repeating-linear-gradient(
                    //   45deg,
                    //   #e1e1e1,
                    //   #e1e1e1 3px,
                    //   #fff 3px,
                    //   #fff 15px
                    // );`
                    // diagonalBackground.value = `repeating-linear-gradient(
                    //    45deg,
                    //    #e1e1e1,
                    //    #e1e1e1 3px,
                    //    #fff 3px,
                    //    #fff 15px
                    //  )`
                    diagonalBackground.value = '#e1e1e1';
                    // eventTextColor.value = `color: ${accentColor};`
                    // eventBorderColor.value = `2px solid ${accentColor}`
                    eventTextColor.value = `color: #667085;`;
                    eventBorderColor.value = `2px solid #e1e1e1`;
                }
            }
        }
        const eventFontSize = computed(() => {
            const d = getTimeDifferenceInMin(props.arg.event.extendedProps.ogEvent.startTime, props.arg.event.extendedProps.ogEvent.endTime);
            switch (true) {
                case d <= 20:
                    return 'text-[10px]';
                case d > 20 && d <= 60:
                    return 'text-xs';
                default:
                    return 'text-md';
            }
        });
        const textOrientation = computed(() => {
            const d = getTimeDifferenceInMin(props.arg.event.extendedProps.ogEvent.startTime, props.arg.event.extendedProps.ogEvent.endTime);
            switch (true) {
                case d <= 20:
                    return 'flex-row items-start gap-1';
                case d > 20 && d <= 30:
                    return 'flex-col';
                default:
                    return 'flex-col';
            }
        });
        const verticalPadding = computed(() => {
            if (props.arg.event.allDay)
                return 'py-0';
            const d = getTimeDifferenceInMin(props.arg.event.extendedProps.ogEvent.startTime, props.arg.event.extendedProps.ogEvent.endTime);
            switch (true) {
                case d <= 45:
                    return 'py-0';
                default:
                    return 'py-1';
            }
        });
        const userEventBorder = computed(() => {
            var _a;
            if (calendarWidgetState.activeView == 'user' ||
                calendarWidgetState.activeView == 'group' ||
                calendarWidgetState.activeView == 'calendar') {
                return `4px solid ${(_a = props.arg.event.extendedProps) === null || _a === void 0 ? void 0 : _a.customColor}`;
            }
            return '';
        });
        const isGoogleEvent = computed(() => {
            const ogEvent = props.arg.event.extendedProps.ogEvent;
            return ('google' in ogEvent &&
                typeof ogEvent.google === 'object' &&
                Object.keys(ogEvent.google).length > 0 &&
                !ogEvent.local);
        });
        const isOutlookEvent = computed(() => {
            const ogEvent = props.arg.event.extendedProps.ogEvent;
            return ('outlook' in ogEvent &&
                typeof ogEvent.outlook === 'object' &&
                Object.keys(ogEvent.outlook).length > 0 &&
                !ogEvent.local);
        });
        const isIcloudEvent = computed(() => {
            const ogEvent = props.arg.event.extendedProps.ogEvent;
            return ('icloud' in ogEvent &&
                typeof ogEvent.icloud === 'object' &&
                Object.keys(ogEvent.icloud).length > 0 &&
                !ogEvent.local);
        });
        function getLinesCount(event) {
            if (event.allDay)
                return 'line-clamp-1';
            if (getTimeDifferenceInMin(event.extendedProps.ogEvent.startTime, event.extendedProps.ogEvent.endTime) <= 75)
                return 'line-clamp-1';
            return 'line-clamp-2';
        }
        onMounted(() => {
            calculateBackground(props.arg);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UITooltip), { placement: "right-start" }, {
                trigger: _withCtx(() => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                    return [
                        _createElementVNode("section", {
                            class: _normalizeClass(`${eventFontSize.value} ${verticalPadding.value} px-1.5 text-xs h-full w-full overflow-hidden rounded-tr rounded-br ${props.arg.event.allDay ? 'mb-1' : 'mb-0'}`),
                            style: _normalizeStyle(Object.assign(Object.assign({ backgroundColor: eventBackgroundColor.value, border: eventBorderColor.value }, (userEventBorder.value
                                ? {
                                    borderLeft: userEventBorder.value,
                                }
                                : {})), (diagonalBackground.value
                                ? {
                                    background: diagonalBackground.value,
                                    opacity: 1,
                                }
                                : {}))),
                            id: props.arg.event.extendedProps.ogEvent.id
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(`flex-1 h-full flex break-words overflow-hidden whitespace-pre-wrap ${eventTextFormat.value} ${textOrientation.value} `),
                                    style: _normalizeStyle(`${eventTextColor.value}`)
                                }, [
                                    _createElementVNode("span", {
                                        style: { "word-wrap": "break-word" },
                                        class: _normalizeClass(`font-semibold break-words ${getLinesCount(props.arg.event)}`)
                                    }, _toDisplayString(((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.arg) === null || _a === void 0 ? void 0 : _a.event) === null || _b === void 0 ? void 0 : _b.title) === null || _c === void 0 ? void 0 : _c.trim()) == ''
                                        ? '(No Title)'
                                        : (_e = (_d = props === null || props === void 0 ? void 0 : props.arg) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.title), 3),
                                    (!props.arg.event.allDay)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: _normalizeClass(`break-words ${getLinesCount(props.arg.event)}`)
                                        }, _toDisplayString(_unref(getTimeDifferenceInMin)(props.arg.event.extendedProps.ogEvent.startTime, props.arg.event.extendedProps.ogEvent.endTime) > 15
                                            ? props.arg.event.extendedProps.timeString
                                            : (_f = props.arg.event.extendedProps.timeString) === null || _f === void 0 ? void 0 : _f.split('-')[0]), 3))
                                        : _createCommentVNode("", true)
                                ], 6),
                                (_unref(getTimeDifferenceInMin)(props.arg.event.extendedProps.ogEvent.startTime, props.arg.event.extendedProps.ogEvent.endTime) > 30 &&
                                    (!props.arg.event.extendedProps.ogEvent.local ||
                                        props.arg.event.extendedProps.ogEvent.status == 'unavailable' ||
                                        ((_k = (_j = (_h = (_g = props === null || props === void 0 ? void 0 : props.arg) === null || _g === void 0 ? void 0 : _g.event) === null || _h === void 0 ? void 0 : _h.extendedProps) === null || _j === void 0 ? void 0 : _j.ogEvent) === null || _k === void 0 ? void 0 : _k.appointmentStatus) ==
                                            _unref(INVALID_APPOINMENT)) &&
                                    !props.arg.event.allDay)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        (isIcloudEvent.value)
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                                            : _createCommentVNode("", true),
                                        (!props.arg.event.extendedProps.ogEvent.isFree &&
                                            props.arg.event.extendedProps.ogEvent.status == 'unavailable')
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                                            : _createCommentVNode("", true),
                                        (isGoogleEvent.value)
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                                            : _createCommentVNode("", true),
                                        (isOutlookEvent.value)
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                                            : _createCommentVNode("", true),
                                        (props.arg.event.extendedProps.ogEvent.isRecurring)
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                                            : _createCommentVNode("", true),
                                        (props.arg.event.extendedProps.ogEvent.appointmentStatus ==
                                            _unref(INVALID_APPOINMENT))
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ], 14, _hoisted_1)
                    ];
                }),
                default: _withCtx(() => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    return [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("p", _hoisted_12, _toDisplayString(((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.arg) === null || _a === void 0 ? void 0 : _a.event) === null || _b === void 0 ? void 0 : _b.title) === null || _c === void 0 ? void 0 : _c.trim()) == ''
                                    ? '(No Title)'
                                    : (_e = (_d = props === null || props === void 0 ? void 0 : props.arg) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.title), 1),
                                (isIcloudEvent.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                                    : _createCommentVNode("", true),
                                (isGoogleEvent.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _hoisted_18,
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)('calendarOverlay.google_icon')), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (isOutlookEvent.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _hoisted_20,
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)('calendarOverlay.outlook_icon')), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (!props.arg.event.extendedProps.ogEvent.isFree &&
                                    props.arg.event.extendedProps.ogEvent.status == 'unavailable')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _hoisted_22,
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)('calendarOverlay.blocked_slot_icon')), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (props.arg.event.extendedProps.ogEvent.isRecurring)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _hoisted_24,
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)('calendarOverlay.recurring_icon')), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (((_j = (_h = (_g = (_f = props === null || props === void 0 ? void 0 : props.arg) === null || _f === void 0 ? void 0 : _f.event) === null || _g === void 0 ? void 0 : _g.extendedProps) === null || _h === void 0 ? void 0 : _h.ogEvent) === null || _j === void 0 ? void 0 : _j.appointmentStatus) ==
                                    _unref(INVALID_APPOINMENT))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _hoisted_26,
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)('calendarOverlay.event_error_icon')), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("p", _hoisted_28, _toDisplayString(props.arg.event.extendedProps.timeString), 1)
                            ])
                        ])
                    ];
                }),
                _: 1
            }));
        };
    }
});
